import event from './event';
import page from './page';
import config from '../config';

export default {
  event,
  page,
  methods: config.methods,
};
